import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import { injectIntl } from "react-intl";
var classNames = require("classnames");
import StateButton from "Components/StateButton";

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";

import API from "../../api/index";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import "react-sortable-tree/style.css";

import { Row, Button, Input, Card, CardBody, CardTitle } from "reactstrap";

import NumberFormat from "react-number-format";
import { Colxx } from "Components/CustomBootstrap";

class ProductPriceManager extends Component {
	constructor(props) {
		super(props);

		this.state = {
			SearchPhrase: "",
			isRefreshing: false,
			productsData: [],
			isLoading: true,
		};

		this.loadData = this.loadData.bind(this);
		this.loadData();
	}

	loadData(key) {
		API.system
			.productPriceGetList({})
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					productsData: data,
					isLoading: false,
					isRefreshing: false,
				});
			})
			.catch((error) => {});
	}

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4">
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<CardTitle>
									<div className={"iconsminds-dollar headingicon"} />
									مدیریت قیمت محصول
									<Button
										className={"default mb-1"}
										outline
										color={"info"}
										style={{ float: "left", border: "unset", width: "40px", borderRadius: 50, padding: "10px" }}
										onClick={() => {
											this.setState({ isRefreshing: true });
											this.loadData();
										}}
									>
										<div className={" simple-icon-reload tableheadingicon"} />
									</Button>
									<div style={{ width: 200, float: "left", display: "inline-block", marginLeft: "10px", borderRadius: 50 }}>
										<Input
											autoComplete="off"
											type="text"
											name="SearchPhrase"
											id="SearchPhrase"
											color="info"
											placeholder=""
											value={this.state.SearchPhrase}
											onChange={(e) => {
												this.setState({ SearchPhrase: e.target.value });
											}}
											style={{ borderRadius: "50px", padding: "9px", lineHeight: "29px", paddingBottom: "5px", paddingTop: "7px", paddingLeft: "35px", paddingRight: "19px" }}
										/>
										<Button
											style={{
												position: "absolute",
												top: 22,
												marginRight: "165px",
												marginTop: "11px",
												fontSize: 20,
												padding: "5px",
												color: "lightgray",
												backgroundColor: "transparent",
												border: "unset",
												display: this.state.SearchPhrase != "" ? "block" : "none",
											}}
											onClick={(e) => {
												this.setState({ SearchPhrase: "" });
											}}
										>
											<i className="simple-icon-close"></i>
										</Button>
									</div>
								</CardTitle>
								{!this.state.isRefreshing ? (
									<div className="table-responsive table-stripped price-manager-table">
										<table className="table table-hover products-table">
											<thead>
												<tr>
													<th>#</th>
													<th>کد محصول</th>
													<th style={{ textAlign: "right" }}>نام محصول</th>
													<th style={{ textAlign: "right" }}>انبارداری؟</th>
													<th style={{ textAlign: "right" }}>فعال؟</th>
													<th>قیمت </th>
													<th>عملیات </th>
												</tr>
											</thead>

											{this.state.productsData
												.filter((row) => {
													return this.state.SearchPhrase.trim() == ""
														? true
														: row.name.indexOf(this.state.SearchPhrase) > -1 ||
																("" + row.price).indexOf(this.state.SearchPhrase.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))) > -1 ||
																row.id.indexOf(this.state.SearchPhrase.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))) > -1;
												})
												.map((row, index) => (
													<TableBodyRows index={index} key={row.id} data={row} />
												))}
										</table>
									</div>
								) : (
									<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
								)}
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	constructor(props) {
		super(props);

		this.state = {
			id: this.props.data.id,
			failed: false,
			clicked: false,
			state: "new",
			active: this.props.data.active,
			initalActive: this.props.data.active,
			initialPrice: this.props.data.price,
			price: this.props.data.price,
		};

		this.handleSaveButtonClick = this.handleSaveButtonClick.bind(this);
	}
	handleSaveButtonClick() {
		this.setState({ clicked: true, failed: false });

		return new Promise((success, fail, $this) => {
			setTimeout(($this) => {
				API.system
					.productPriceUpdateItem({ ID: this.state.id, PRICE: this.state.price, ACTIVE: this.state.active })
					.then((data) => {
						data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
						if (data.DONE == true) {
							success("تغییرات ثبت شد");
							setTimeout(() => {
								this.setState({ initalActive: this.state.active, initialPrice: this.state.price, clicked: false, failed: false });
							}, 2000);
						} else {
							this.setState({ clicked: false, failed: true });
							fail("مشکل در ذخیره تغییرات");
						}
					})
					.catch((error) => {
						this.setState({ clicked: false, failed: true });
						fail("مشکل در ذخیره تغییرات");
					});
			}, 10);
		});
	}

	render() {
		const {
			data: { id, price, name, ProductObject },
		} = this.props;
		var paymentColorClass = this.state.status == "new" ? "white" : "lightgreen";
		var btnColor = "primary";
		if (this.state.price == this.state.initialPrice && this.state.active == this.state.initalActive && !this.state.failed) {
			btnColor = "light";
		}
		if (this.state.failed) {
			btnColor = "danger";
		}

		return (
			<tbody
				className={classNames({
					"saving-row": this.state.clicked,
				})}
			>
				<tr className={"order-spacer"}></tr>
				<tr className={"product-item"}>
					<td> {this.props.index + 1} </td>
					<td>
						<a href={`https://hub.akschap.com/node/${id}`} target="_blank">
							#{id}
						</a>{" "}
					</td>
					<td style={{ textAlign: "right" }}>{name}</td>
					<td style={{ textAlign: "right" }}>{ProductObject.canStock ?<i className="simple-icon-check"></i>: ""}</td>
					<td>
						<Switch
							className="custom-switch custom-switch-primary"
							checked={this.state.active}
							disabled={this.state.clicked}
							onChange={(active) => {
								this.setState({ active });
							}}
						/>
					</td>
					<td className={"text-muted"}>
						<NumberFormat
							disabled={this.state.clicked}
							value={this.state.price}
							onValueChange={(values) => {
								this.setState({ price: values.value });
							}}
							thousandSeparator={true}
						/>{" "}
						تومان
					</td>
					<td className={"text-muted"}>
						<StateButton
							kye={id}
							id={"cardButton" + id}
							placement="right"
							className={"default md-2"}
							color={btnColor}
							disabled={this.state.price == this.state.initialPrice && this.state.active == this.state.initalActive}
							onClick={this.handleSaveButtonClick}
						>
							ذخیره
						</StateButton>
					</td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(ProductPriceManager));
// export default injectIntl(ProductPriceManager);
